










import { genVuexComputeds } from '@/main/pages/editFactory';
import zalohaComponentBuilder from '@/modules/components/zalohy/Edit.vue';
import { zalohyFactory } from '@/modules/components/zalohy/edit';
import { openEdit } from '@/main/router/routerPath';
import { DokladNaplnFakturaci, NAME as FAKTURACE } from '@/modules/uctenky/fakturace/constants';
import { PageMode } from '@/main/utils/pageMode';
import _ from 'lodash';

import { store } from './store/edit';
import { NAME } from './constants';

export default zalohyFactory(NAME, store).extend({
	name: NAME,
	components: {
		Zalohy: zalohaComponentBuilder,
	},
	data() {
		return {
			vuexStore: store,
			DokladNaplnFakturaci,
		};
	},
	computed: {
		...genVuexComputeds(store),
		isZalohovaFakturaDisabled() {
			return !_.isNull(this.UzavreniDat);
		},
		isPrvniDdDisabled() {
			return _.isNull(this.UzavreniDat) || !_.isNull(this.PrvniDdDat);
		},
	},
	methods: {
		async zalohovaFaktura(dokladNaplnFakturaci: DokladNaplnFakturaci) {
			if (this.isCreateMode) await this.changeToEdit();
			if (this.isModified) await this.save(false);

			openEdit(FAKTURACE, PageMode.CREATE, {
				filter: {
					povId: this.PovId,
					PovZalohaId: this.PovzalohaId,
					dokladNaplnFakturaci,
				},
			});
		},
	},
});
